// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2Lh9G","row":"Node_row__27WPf","label":"Node_label__3H0z3","footer":"Node_footer__3cv1b"};